import { useState } from 'react';
import questionIcon from '../../assets/icons/DashboardIcons/question.svg';
import Button from '../global/Button';

type DashboardAmountDetailsProps = {
  label: string;
  value: string;
  icon: string;
  hint?: string;
};
const DashboardAmountDetails = ({ label, value, icon, hint }: DashboardAmountDetailsProps) => {
  const [showTooltip, setShowTooltip] = useState(false);
  return (
    <div className='mb-[16px] sm:border-[#DDDDDD] rounded-md border py-2 px-3'>
      <div className='flex flex-col items-end relative gap-2'>
        <div
          className='hidden md:flex justify-end cursor-pointer'
          onClick={() => setShowTooltip(!showTooltip)}
        >
          <img src={questionIcon} alt='question-icon' title={hint} />
        </div>
        {showTooltip && (
          <div className='w-[248px] top-6  absolute z-50 justify-end transition-all pb-1 bg-white rounded-md shadow-smYellow'>
            <p className='font-poppins text-xs  pt-2 pl-3 pr-6 '>{hint}</p>
            <div className='flex justify-end pr-4 pt-[6px] '>
              <button
                onClick={() => setShowTooltip(!showTooltip)}
                className='text-green font-normal text-xs font-poppins'
              >
                Close
              </button>
            </div>
          </div>
        )}
      </div>
      <div className='space-y-4'>
        <div className='flex items-center pl-2 justify-start space-x-3'>
          <img src={icon} alt={icon} />
          <h2 className='font-normal font-poppins text-sm text-[#212121]'>{label}</h2>
        </div>
        <div className='flex pt-[28px] justify-between'>
          <div className='flex items-center justify-center '>
            <h3 className='text-[13px] font-poppins flex bg-[#049E2621] p-[3px] text-green'>
              NGR{' '}
            </h3>
            <span className='text-[27px] font-poppins  tracking-tighter pl-[6px] font-medium'>
              {value}
            </span>
          </div>
          {label === 'Revenue' ? (
            <svg
              width='82'
              height='52'
              viewBox='0 0 82 52'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M0.644682 50.4588C0.63755 50.7084 0.834134 50.9166 1.08377 50.9237L5.15174 51.0399C5.40137 51.0471 5.60952 50.8505 5.61666 50.6008C5.62379 50.3512 5.4272 50.1431 5.17757 50.1359L1.56159 50.0326L1.66491 46.4166C1.67204 46.167 1.47545 45.9589 1.22582 45.9517C0.976191 45.9446 0.768043 46.1412 0.76091 46.3908L0.644682 50.4588ZM17.3752 35.0975L17.6794 34.7629L17.3694 34.4811L17.0648 34.7688L17.3752 35.0975ZM27.3232 44.1412L27.0191 44.4757L27.3529 44.7793L27.6572 44.446L27.3232 44.1412ZM46.3149 23.3408L46.5951 22.9859L46.2647 22.7251L45.9809 23.0359L46.3149 23.3408ZM54.9063 30.1235L54.6261 30.4784L54.9632 30.7445L55.2463 30.4217L54.9063 30.1235ZM81.0207 1.02982C81.1853 0.842059 81.1666 0.556367 80.9788 0.391712C80.7911 0.227057 80.5054 0.245791 80.3407 0.433555L81.0207 1.02982ZM1.40716 50.8004L17.6857 35.4263L17.0648 34.7688L0.786201 50.143L1.40716 50.8004ZM17.0711 35.4321L27.0191 44.4757L27.6274 43.8066L17.6794 34.7629L17.0711 35.4321ZM27.6572 44.446L46.6488 23.6457L45.9809 23.0359L26.9893 43.8363L27.6572 44.446ZM46.0347 23.6957L54.6261 30.4784L55.1865 29.7686L46.5951 22.9859L46.0347 23.6957ZM55.2463 30.4217L81.0207 1.02982L80.3407 0.433555L54.5664 29.8254L55.2463 30.4217Z'
                fill='#FF0000'
              />
            </svg>
          ) : (
            <svg
              width='82'
              height='51'
              viewBox='0 0 82 51'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M0.789131 50.143C0.607571 50.3144 0.599394 50.6006 0.770867 50.7822C0.94234 50.9637 1.22853 50.9719 1.41009 50.8004L0.789131 50.143ZM17.3782 35.0975L17.6823 34.7629L17.3723 34.4811L17.0677 34.7688L17.3782 35.0975ZM27.3262 44.1412L27.022 44.4757L27.3559 44.7793L27.6601 44.446L27.3262 44.1412ZM46.3178 23.3408L46.598 22.9859L46.2677 22.7251L45.9839 23.0359L46.3178 23.3408ZM54.9093 30.1235L54.6291 30.4784L54.9661 30.7445L55.2492 30.4217L54.9093 30.1235ZM81.1349 0.702102C81.1185 0.452904 80.9033 0.264136 80.6541 0.280477L76.5931 0.546766C76.3439 0.563107 76.1552 0.778369 76.1715 1.02757C76.1879 1.27676 76.4031 1.46553 76.6523 1.44919L80.262 1.21249L80.4987 4.82219C80.5151 5.07139 80.7303 5.26016 80.9795 5.24382C81.2287 5.22748 81.4175 5.01222 81.4011 4.76302L81.1349 0.702102ZM1.41009 50.8004L17.6886 35.4263L17.0677 34.7688L0.789131 50.143L1.41009 50.8004ZM17.074 35.4321L27.022 44.4757L27.6303 43.8066L17.6823 34.7629L17.074 35.4321ZM27.6601 44.446L46.6517 23.6457L45.9839 23.0359L26.9922 43.8363L27.6601 44.446ZM46.0376 23.6957L54.6291 30.4784L55.1895 29.7686L46.598 22.9859L46.0376 23.6957ZM55.2492 30.4217L81.0236 1.02982L80.3437 0.433555L54.5693 29.8254L55.2492 30.4217Z'
                fill='#049E26'
              />
            </svg>
          )}
        </div>
        <div className='flex  justify-between'>
          <div>
            <Button className='text-xs font-poppins !px-4 !py-2'>View Account</Button>
          </div>
          <div className='flex items-center space-x-2'>
            <svg
              width='8'
              height='9'
              viewBox='0 0 8 9'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M4.42521 0.578208C4.24862 0.40162 3.96232 0.40162 3.78573 0.578208L0.908059 3.45588C0.731471 3.63246 0.731471 3.91877 0.908059 4.09536C1.08465 4.27195 1.37095 4.27195 1.54754 4.09536L4.10547 1.53743L6.6634 4.09536C6.83998 4.27195 7.12629 4.27195 7.30288 4.09536C7.47947 3.91877 7.47947 3.63247 7.30288 3.45588L4.42521 0.578208ZM3.65329 0.897949L3.65329 8.13286L4.55765 8.13286L4.55765 0.897949L3.65329 0.897949Z'
                fill='#212121'
              />
            </svg>

            <p className='text-[#212121] font-poppins font-normal text-[9px]'>
              +0.0 % vs Last 7 days
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardAmountDetails;
